import React from 'react'

import type { Befehl } from '../../models'
import { BefehlFormProps } from './Generic'
import { Befehl1Form } from './Befehl1'
import { Befehl2Form } from './Befehl2'
import { Befehl3Form } from './Befehl3'
import { Befehl4Form } from './Befehl4'
import { Befehl5Form } from './Befehl5'
import { Befehl6Form } from './Befehl6'
import { Befehl7Form } from './Befehl7'
import { Befehl8Form } from './Befehl8'
import { Befehl9Form } from './Befehl9'
import { Befehl21Form } from './Befehl21'
import { Befehl22Form } from './Befehl22'
import { Befehl23Form } from './Befehl23'
import { Befehl24Form } from './Befehl24'
import { Befehl25Form } from './Befehl25'
import { Befehl26Form } from './Befehl26'
import { Befehl27Form } from './Befehl27'
import { Befehl28Form } from './Befehl28'
import { Befehl29Form } from './Befehl29'
import { Befehl30Form } from './Befehl30'
import { Befehl31Form } from './Befehl31'
import { Befehl32Form } from './Befehl32'
import { Befehl33Form } from './Befehl33'
import { Befehl34Form } from './Befehl34'
import { Befehl95Form } from './Befehl95'
import GrundDialogProvider from '../../providers/GrundDialogProvider'

/**
 * All available BefehlForm components
 */
const allBefehlForms = {
  Befehl1Form,
  Befehl2Form,
  Befehl3Form,
  Befehl4Form,
  Befehl5Form,
  Befehl6Form,
  Befehl7Form,
  Befehl8Form,
  Befehl9Form,
  Befehl21Form,
  Befehl22Form,
  Befehl23Form,
  Befehl24Form,
  Befehl25Form,
  Befehl26Form,
  Befehl27Form,
  Befehl28Form,
  Befehl29Form,
  Befehl30Form,
  Befehl31Form,
  Befehl32Form,
  Befehl33Form,
  Befehl34Form,
  Befehl95Form
}

/**
 * Dynamically build the befehl form map from all imported BefehlXForm components
 */
const befehlFormMap: Record<
  string,
  React.ComponentType<BefehlFormProps<Befehl>>
> = {}

// Dynamically populate the map with all BefehlXForm components
for (const [key, component] of Object.entries(allBefehlForms)) {
  const match = /^Befehl(\d+)Form$/.exec(key)
  if (match) {
    const befehlNumber = match[1]
    befehlFormMap[befehlNumber] = component as React.ComponentType<
      BefehlFormProps<Befehl>
    >
  }
}

/**
 * Get list of supported Befehl numbers dynamically
 */
export const getSupportedBefehle = (): string[] => {
  return Object.keys(befehlFormMap).sort(
    (a, b) => Number.parseInt(a) - Number.parseInt(b)
  )
}

/**
 * Check if a Befehl is supported
 */
export const isSupportedBefehl = (kennung: string): boolean => {
  return kennung in befehlFormMap
}

export default function BefehlForm({
  befehl,
  onSubmit,
  'data-testid': testId,
  readOnly = false,
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl>>) {
  const FormComponent = befehlFormMap[befehl.kennung]
  if (FormComponent) {
    return (
      <GrundDialogProvider>
        <FormComponent
          befehl={befehl}
          onSubmit={onSubmit}
          data-testid={testId}
          readOnly={readOnly}
          displayHeaderOnly={displayHeaderOnly}
          activateEmptyFieldWarnings={activateEmptyFieldWarnings}
        />
      </GrundDialogProvider>
    )
  }
  return null
}
